import { render, staticRenderFns } from "./ColorableGallery.vue?vue&type=template&id=d468ea16"
import script from "./ColorableGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorableGallery.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ColorableGallery.vue?vue&type=style&index=0&id=d468ea16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports